<template>
  <div class="register">
    <div class="content">
      <div class="title">
        使用手机号注册
      </div>
      <div class="phone_box">
        <i class="icon"><img src="../assets/img/icon_phone.png" alt=""></i>
        <input v-model="params.phone" class="input" type="tel"  placeholder="手机号">
      </div>
      <div class="password_box">
        <i class="icon"><img src="../assets/img/icon_phone.png" alt=""></i>
        <input v-model="params.password" class="input" type="password"  placeholder="密码">
      </div>
      <div class="name_box">
        <i class="icon"><img src="../assets/img/icon_phone.png" alt=""></i>
        <input v-model="params.realName" class="input" type="text"  placeholder="真实姓名">
      </div>
      <div class="ident_box">
        <i class="icon"><img src="../assets/img/icon_code.png" alt=""></i>
        <input v-model="params.verifyCode" class="input" type="text" placeholder="验证码">
        <img @click="getCode()" class="ident_img" :src="'data:image/png;base64,' + codeImg"> 
      </div>
      <div class="note_box">
        <i class="icon"><img src="../assets/img/icon_mail.png" alt=""></i>
        <input v-model="params.smsCode" class="input" type="text" placeholder="短信验证码">
         <p @click="getMail" v-if="getShow">发送验证码</p>
        <p v-if="!getShow">{{time}}秒</p>
      </div>
      <div class="error_msg">
       <span>{{error}}</span>
      </div>
      <a class="login_btn" href="javascript:;" @click="register">注册</a>
      <div class="tip_msg">
        <span>已有账号</span>
        <a href="javascript:;" @click="$router.push({name:'login',query:{fromDetail:fromDetail,from:from}})">直接登录</a>
      </div>
    </div>
  </div>
</template>

<script>
import { setToken } from '../utils/auth'
export default {
  data () {
    return {
      params:{
        phone: '',
        password:'',
        realName:'',
        verifyCode:'',
        smsCode:'',
        encryptVerifyCode:''
      },
      codeImg:'',
      error:'',
      time: 60,
      getShow: true,
      from:'',
      fromDetail:false
    }
  },
  mounted() {
    this.fromDetail = this.$route.query.fromDetail;
    this.from = this.$route.query.from;
    this.getCode();
  },
  methods: {
    getMail(){
      this.$axios.get('/pub/sms/get-sms-code?phone='+ this.params.phone).then(res => {
        if(res.code != 200){
          this.error = res.message;
        }else{
          this.timeReturn(this.time);
          this.getShow = false;
        }
        
      })
    },
    timeReturn(time){
      let $this = this
      if(time == 0){
        $this.getShow = true;
      }else{
        $this.time--
        setTimeout(function(){ 
          $this.timeReturn($this.time);
        },1000) 
      } 
    },
    getCode(){
      this.$axios.get('/pub/verify_code/get-img').then(res => {
        this.codeImg = res.data.codePicBase64;
        this.params.encryptVerifyCode = res.data.code;
      })
    },
    register(){
      this.error = '';
      if (!this.params.phone) {
        this.error = '请输入手机号码';
        return;
      }
      if (!this.params.password) {
        this.error = '请输入密码';
        return;
      }
      if (!this.params.verifyCode) {
        this.error = '请输入验证码';
        return;
      }
      if (!this.params.realName) {
        this.error = '请输入真实名称';
        return;
      }
      if (!this.params.smsCode) {
        this.error = '请输入短信验证码';
        return;
      }
      if (!this.constant.validate.phone.test(this.params.phone)) {
        this.error = '手机号输入有误，请重新输入';
        return;
      }
      if (!this.constant.validate.password.test(this.params.password)) {
        this.error = '密码输入有误，请重新输入';
        return;
      }
      if (!this.constant.validate.verifyCode.test(this.params.verifyCode)) {
        this.error = '验证码输入有误，请重新输入';
        this.params.verifyCode = '';
        this.getCode();
        return;
      }
      if (!this.constant.validate.realName.test(this.params.realName)) {
        this.error = '请重新输入真实名称';
        return;
      }

      this.error = '';
      this.$axios.post('/api/web/phone/auth/register', this.params).then(res => {
        if(res.code != 200){
          this.error = res.message;
          local_store.set_cookie = function (cname, cvalue, exdays) {
            var d = new Date()
            d.setTime(d.getTime() + (exdays*24*60*60*1000))
            var expires = 'expires='+d.toUTCString()
            document.cookie = cname + '=' + cvalue + '; ' + expires
          }
          this.local_store.set_cookie("token",res);
        }else{
          this.Toast("注册成功");
          setToken(res.data.token);
          if(this.fromDetail){
            this.$router.go(-1)
          }else{
            if(!this.from){
              this.$router.push('user');
            }else{
              
              this.$router.push(this.from);
            }
          }
        }
      })

    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/sass/global.scss';
  .register {
    background: #F5F5F5;
    height: 100vh;
    padding:69px 15px 0 15px;
    box-sizing:border-box;
  }
  .content {
    .title{
      color: #666666;
      font-size: 16px;
      font-weight: 600;
    }
    .fl{
      float: left
    }
    .fr{
      float: right
    }
    .tab_item{
      width:83px;
      height:30px;
      background: #F5F5F5;
      border-radius:3px;
      font-size:16px;
      color:#666666;
      line-height:30px;
      text-align: center;
    }
    .tab_item.checked{
      background:#5FD5CA;
      color:#fff;
    }
    .input{
      width:345px;
      height:43px;
      border-radius:5px;
      border:1px solid #E0E0E0;
      color: #999;
      padding-left: 54px;
      font-size: 14px;
      box-sizing: border-box;
    }
    .phone_box{
      margin-top: 30px;
      position: relative;
      .icon{
        display: inline-block;
        position: absolute;
        left: 15px;
        top: 11px;
        width: 13px;
        height: 21px;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .password_box{
      margin-top: 20px;
      position: relative;
      .icon{
        display: inline-block;
        position: absolute;
        left: 15px;
        top: 11px;
        width: 13px;
        height: 21px;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .name_box{
      margin-top: 20px;
      position: relative;
      .icon{
        display: inline-block;
        position: absolute;
        left: 15px;
        top: 11px;
        width: 13px;
        height: 21px;
        img{
          width: 100%;
          height: 100%;
        }
      }
    }
    .ident_box{
      text-align: left;
      margin-top: 20px;
      position: relative;
      .icon{
        display: inline-block;
        position: absolute;
        left: 15px;
        top: 10px;
        width: 15px;
        height: 20px;
        img{
          width: 100%;
          height: 100%;
          content:normal !important;
        }
      }
      .input{
        width: 247px;
      }
      img{
        display: inline-block;
        position: absolute;
        right: 0;
        top: 2px;
        width: 88px;
        height: 38px;
      }
    }
    .note_box{
      margin-top: 20px;
      position: relative;
      .icon{
        display: inline-block;
        position: absolute;
        left: 14px;
        top: 13px;
        width: 18px;
        height: 13px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .input{
        padding-right: 95px;
      }
      p{
        position: absolute;
        right: 0;
        display: inline-block;
        width: 92px;
        text-align: center;
        top: 13px;
        font-size: 12px;
        color:#5FD5CA;
        border-left: 1px solid #D8D8D8;
      }
    }
    .error_msg{
      color:#FD6262;
      font-size: 13px;
      padding-left:66px;
      text-align: left;
      margin-top: 10px;
      min-height: 18px;
    }
    .login_btn{
      display: inline-block;
      width:345px;
      height:43px;
      line-height:43px;
      background:#5FD5CA;
      border-radius:5px;
      font-size:16px;
      color:#fff;
      margin-top: 15px;
      text-align: center;
    }
    .tip_msg{
      margin-top: 31px;
      font-size: 14px;
      color: #999999;
      text-align: center;
      a{
        color: #5FD5CA;
        margin-left: 5px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/register.vue